import { createAction } from 'redux-actions'

const ns = 'integration/'

export const setIntegration = createAction(`${ns}SET_INTEGRATION`)
export const setIntegrationSuccess = createAction(`${ns}SET_INTEGRATION_SUCCESS`)
export const setIntegrationFail = createAction(`${ns}SET_INTEGRATION_FAIL`)

export const endIntegration = createAction(`${ns}END_INTEGRATION`)
export const endIntegrationSuccess = createAction(`${ns}END_INTEGRATION_SUCCESS`)
export const endIntegrationFail = createAction(`${ns}END_INTEGRATION_FAIL`)

export const syncIntegration = createAction(`${ns}SYNC_INTEGRATION`)
export const syncIntegrationSuccess = createAction(`${ns}SYNC_INTEGRATION_SUCCESS`)
export const syncIntegrationFail = createAction(`${ns}SYNC_INTEGRATION_FAIL`)

export const appleHealthIntegration = createAction(`${ns}APPLE_HEALTH_INTEGRATION`)

export const initialAppleHealthIntegration = createAction(`${ns}INITIAL_APPLE_HEALTH_INTEGRATION`)

export const initializeGarminIntegration = createAction(`${ns}INITIALIZE_GARMIN_INTEGRATION`)
export const finalizeGarminIntegration = createAction(`${ns}FINALIZE_GARMIN_INTEGRATION`)
